// AUTO-GENERATED — character slugs that have an animated card video in Supabase
// storage (eros-media/character-videos/<slug>.mp4). Regenerate with
// scripts/reference-characters after uploading new clips.

const STORAGE_BASE =
  'https://bjhhccyzlmjpgurefeef.supabase.co/storage/v1/object/public/eros-media/character-videos';

export const ANIMATED_SLUGS = new Set<string>([
  '-5c5ej7',
  'Sofia-volkov',
  'abimbola-ifunanya',
  'aiko-shimizu',
  'akari-tanaka',
  'amani-nkosi',
  'amara-nandi',
  'amina-osei',
  'amira-osei',
  'amora-d1kkbo',
  'anaya-sharma',
  'anika-joshi',
  'anjali-devi',
  'anmed-ravena',
  'anna-nowak',
  'anya-al-khatib',
  'aoife-murphy',
  'astrid-bergstr-m',
  'astrid-bergstr-m-1',
  'astrid-bjornstad-1',
  'aya-bousso',
  'ayana-okoro',
  'bianca-moretti',
  'briar-thorne',
  'brunhilde-ackermann',
  'brunhilde-bruiser-schmidt',
  'camilla-santos',
  'camille-laurent',
  'catalina-herrera',
  'catalina-herrera-1',
  'cleo-hassan',
  'deepika-iyer',
  'eirwen-forseti',
  'elara-moreau-1',
  'elara-morozova',
  'elara-vasilievna',
  'elara-vestby',
  'eleanor-ainsworth',
  'eleanor-fitzgerald',
  'elena-kowalski',
  'elena-mendoza',
  'elena-popescu',
  'elin-solbj-rg',
  'elsa-andersson',
  'emma-de-jong',
  'emma-johnson',
  'esmeralda-esme-cruz',
  'eszter-kovacs',
  'freja-larsson',
  'freja-lundstr-m',
  'freja-petersen',
  'freya-hartmann',
  'freya-volkov',
  'genevieve-dubois',
  'giulia-rossi',
  'greta-edelmann',
  'greta-hoffmann',
  'greta-m-ller',
  'han-mei-li',
  'helena-petrova',
  'himari-amamiya',
  'ifiok-nkanga',
  'ines-santos',
  'inge-sveinsdottir',
  'ingrid-s-rensen',
  'isabela-castillo',
  'isabela-de-souza',
  'isabela-flores',
  'isabella-moretti',
  'isabella-rodriguez',
  'isabella-vasquez',
  'isobel-von-dorn',
  'isolde-von-richter',
  'jana-qo5xkr',
  'jasleen-kaur-shergill',
  'jia-yue',
  'kaiyo-tanaka',
  'kanya-the-phoenix-arayakorn',
  'kasumi-nakamura',
  'lana-al-masri',
  'lea-martin',
  'lin-zheng',
  'louisa-edelweiss',
  'maria-papadopoulou',
  'marisol-esperanza',
  'mathlida-winchester',
  'meenakshi-sundaram',
  'meera-chakravarti',
  'mei-tanaka',
  'mei-tanaka-1',
  'nadya-chen',
  'nala-adu-darko',
  'nala-moremi',
  'naserian-mollel',
  'neferet-ra-neferu',
  'odette-moreau',
  'olivia-smith',
  'princess-aeisha-meher-chand',
  'rani-devi',
  'ren-kumo',
  'riya-patel',
  'rosa-delgado',
  'rosario-rosie-vargas',
  'sable-moreau',
  'sade-adebayo',
  'sakura-nakamura',
  'sigrid-larsen',
  'sofia-ivanova',
  'sofia-laurent',
  'sofia-mendoza',
  'sofia-morales',
  'solveig-haardrad',
  'solveig-nygaard',
  'solveig-strom',
  'sophie-dubois',
  'temiloluwa-temi-adeyemi',
  'tigist-alemayehu',
  'tove-christensen',
  'valentina-espinoza',
  'valentina-la-bruja-morales',
  'valentina-rivera',
  'valentina-vale-cruz',
  'vivienne-deschamps',
  'x-chitl-guzm-n',
  'yasmin-al-mansoori',
  'yasmin-hassan',
  'yasmin-karimi',
  'yukiko-tanaka',
  'yumi-nakamura',
  'zahra-khaled',
  'zahra-nour',
  'zahra-nour-1',
  'zara-volkov',
  // 2026-07 batch (Drive upload)
  'aurora-thatcher',
  'bianca-costa',
  'freya-lindqvist',
  'margot-laurent',
  'mei-lin',
  'mia-rossi',
  'nova-taylor',
  'selena-marino',
  'shirley-wong',
  'valeria-popescu',
]);

// Bump when the stored clips are re-encoded — busts the year-long CDN/browser
// cache so viewers fetch the new file instead of the stale one.
// v3 = native 720p/30fps H.264 CRF26 from the local masters (sharp, ~1MB).
const CLIP_VERSION = '3';

/** Public URL of a character's looping card video, or null if none exists. */
export function characterVideoUrl(slug: string): string | null {
  return ANIMATED_SLUGS.has(slug)
    ? `${STORAGE_BASE}/${slug}.mp4?v=${CLIP_VERSION}`
    : null;
}
